/* eslint-disable no-param-reassign */
import {
  fibreOfferField,
  fieldAddProductVulcan,
  fieldNumberOfAccessPoints,
  fieldProvinceVUL,
  fieldSelectTheDevice,
  CONSTANT
} from '../../utils/constant';
import { getFieldValue } from '../utils';
import {
  fibreSpeed,
  fieldInstallation
} from '../vulcanPricing/fibeInternet/fibreInternetFieldNames';
import EN from '../../../EN.json';
import FR from '../../../FR.json';
import { useLocaleContext } from '../../context/LocaleContext';

const { CORP_STORE } = CONSTANT.KEYS.CHANNELS;

const disableOptions = (options, targets, value) => {
  const updatedOptions = [...options];
  targets.forEach(target => {
    updatedOptions.forEach(option => {
      if (option.fields.value === target) {
        // eslint-disable-next-line no-param-reassign
        option.fields.disabledOption = value;
      }
    });
  });
  return updatedOptions;
};

const FibreBusinessWifiHelpers = ({ formFields, fieldName, fields, orderData, channelName }) => {
  const locale = useLocaleContext();

  const {
    vulcanWebform: {
      vulBusinessWifi,
      vulOnePointFiveG,
      vulThreeG,
      vulOneG,
      vulHundredDollarInstallationFee,
      vulTenDollarInternetBundleDiscount,
      vulHundredBillCreditHSIA,
      vulFifteenDollarInternetBundleDiscountATL,
      vulBTLOption,
      vulATLOption,
      vulFortyDollarInternetDiscountATL,
      vulTwentyDollarInternetDiscountBTL,
      vulTenDollarWifiBundleDiscount,
      vulOneDollarInternetBundleDiscount,
      vulSixtyDollarInternetDiscountATL,
      vulSixtyDollarInternetDiscountBTL,
      vulFifteenDollarInternetBundleDiscount,
      vulSeventyDollarInternetDiscount,
      vulSeventyFiveDollarInternetDiscount,
      vulFortyFiveDollarInternetDiscountATL,
      vulTwentyFiveInternetBundleDiscount,
      vulEightyDollarInternetDiscount,
      vulThirtyInternetBundleDiscount,
      vulNintyInternetBundleDiscount,
      vulWifiTenDollarDiscountAtlBtl,
      vulHundredDollarBillCreditAtlBtl,
      vulThirtyDollarInternetDiscount,
      vulFiftyDollarInternetDiscount,
      vulThirtyFiveDollarInternetDiscount
    }
  } = locale === 'en-US' ? EN : FR;

  const threeGOffers = [
    vulFifteenDollarInternetBundleDiscount,
    vulHundredBillCreditHSIA,
    vulSeventyDollarInternetDiscount
  ];

  const onePointFiveGOffers = [
    vulTenDollarInternetBundleDiscount,
    vulFortyFiveDollarInternetDiscountATL,
    vulSeventyDollarInternetDiscount,
    vulHundredBillCreditHSIA,
    vulFifteenDollarInternetBundleDiscount
  ];

  const threeGOffersForQuebec = [
    vulFifteenDollarInternetBundleDiscountATL,
    // vulTwentyDollarInternetDiscountBTL,
    // vulThirtyInternetBundleDiscount,
    // vulFortyDollarInternetDiscountATL,
    vulTenDollarWifiBundleDiscount,
    // vulSeventyDollarInternetDiscount,
    vulSeventyFiveDollarInternetDiscount,
    vulHundredBillCreditHSIA,
    vulWifiTenDollarDiscountAtlBtl
  ];

  const onePointFiveGOffersForQuebec = [
    // vulTwentyFiveInternetBundleDiscount,
    // vulThirtyInternetBundleDiscount,
    // vulSixtyDollarInternetDiscountBTL,
    // vulNintyInternetBundleDiscount,
    vulFifteenDollarInternetBundleDiscount,
    vulTenDollarInternetBundleDiscount,
    vulSixtyDollarInternetDiscountATL,
    vulSeventyDollarInternetDiscount,
    vulHundredBillCreditHSIA,
    vulTenDollarWifiBundleDiscount,
    vulOneDollarInternetBundleDiscount,
    vulWifiTenDollarDiscountAtlBtl,
    vulFiftyDollarInternetDiscount
    
  ];

  const onePointFiveGOffersForOntario = [
    // vulTwentyFiveInternetBundleDiscount,
    // vulThirtyInternetBundleDiscount,
    // vulSixtyDollarInternetDiscountBTL,
    // vulNintyInternetBundleDiscount,
    vulFifteenDollarInternetBundleDiscount,
    vulTenDollarInternetBundleDiscount,
    // vulFortyFiveDollarInternetDiscountATL,
    vulSeventyDollarInternetDiscount,
    vulHundredBillCreditHSIA,
    vulTenDollarWifiBundleDiscount,
    vulOneDollarInternetBundleDiscount,
    vulWifiTenDollarDiscountAtlBtl,
    vulThirtyFiveDollarInternetDiscount
  ];

  const threeGOffersForOntario = [
    vulFifteenDollarInternetBundleDiscountATL,
    // vulFortyDollarInternetDiscountATL,
    // vulFifteenDollarInternetBundleDiscount, // SOF-3077
    // vulSeventyDollarInternetDiscount,
    vulTenDollarWifiBundleDiscount,
    // vulThirtyInternetBundleDiscount,
    vulSeventyFiveDollarInternetDiscount,
    vulHundredBillCreditHSIA,
    vulWifiTenDollarDiscountAtlBtl
  ];

  const oneGOffers = [
    vulWifiTenDollarDiscountAtlBtl,
    vulHundredDollarBillCreditAtlBtl,
    vulSeventyDollarInternetDiscount,
    vulFortyFiveDollarInternetDiscountATL,
    vulThirtyDollarInternetDiscount
  ];

  const oneGOffersForQuebec = [
    vulWifiTenDollarDiscountAtlBtl,
    vulHundredDollarBillCreditAtlBtl,
    vulSeventyDollarInternetDiscount,
    vulFortyFiveDollarInternetDiscountATL,
  ];

  const oneGOffersForOntario = [
    vulWifiTenDollarDiscountAtlBtl,
    vulHundredDollarBillCreditAtlBtl,
    vulSeventyDollarInternetDiscount,
    vulThirtyDollarInternetDiscount
  ];

  // Province constants
  const QUEBEC_PROVINCES = ['quebec', 'québec', 'qc', 'pq'];
  const ONTARIO_PROVINCES = ['ontario', 'on', 'ont'];

  // Helper function to check province
  const isProvinceInList = (serviceAddress, provinceList) => {
    return provinceList.includes((serviceAddress || '').toLowerCase());
  };

  const getValidOffersForSpeed = (
    formFields,
    fieldName
  ) => {
    if (fieldName === fibreOfferField) {
      const fibreSpeedFieldValue = getFieldValue(fibreSpeed, formFields);
      const serviceAddress = getFieldValue(fieldProvinceVUL, formFields);
      let validOptions = formFields[fibreOfferField].options;

      if (fibreSpeedFieldValue === vulThreeG) {
        if (isProvinceInList(serviceAddress, QUEBEC_PROVINCES)) {
          validOptions = formFields[fibreOfferField].options.filter(value =>
            threeGOffersForQuebec.includes(value.fields.value)
          );
        } else if (isProvinceInList(serviceAddress, ONTARIO_PROVINCES)) {
          validOptions = formFields[fibreOfferField].options.filter(value =>
            threeGOffersForOntario.includes(value.fields.value)
          );
        } else {
          validOptions = formFields[fibreOfferField].options.filter(value =>
            threeGOffers.includes(value.fields.value)
          );
        }
      } else if (fibreSpeedFieldValue === vulOnePointFiveG) {
        if (isProvinceInList(serviceAddress, QUEBEC_PROVINCES)) {
          validOptions = formFields[fibreOfferField].options.filter(value =>
            onePointFiveGOffersForQuebec.includes(value.fields.value)
          );
        } else if (isProvinceInList(serviceAddress, ONTARIO_PROVINCES)) {
          validOptions = formFields[fibreOfferField].options.filter(value =>
            onePointFiveGOffersForOntario.includes(value.fields.value)
          );
        } else {
          validOptions = formFields[fibreOfferField].options.filter(value =>
            onePointFiveGOffers.includes(value.fields.value)
          );
        }
      } else if (fibreSpeedFieldValue === vulOneG) {
        if (isProvinceInList(serviceAddress, QUEBEC_PROVINCES)) {
          validOptions = formFields[fibreOfferField].options.filter(value =>
            oneGOffersForQuebec.includes(value.fields.value)
          );
        } else if (isProvinceInList(serviceAddress, ONTARIO_PROVINCES)) {
          validOptions = formFields[fibreOfferField].options.filter(value =>
            oneGOffersForOntario.includes(value.fields.value)
          );
        } else {
          validOptions = formFields[fibreOfferField].options.filter(value =>
            oneGOffers.includes(value.fields.value)
          );
        }
      }

      // Filter out ATL offers for Corp Store channel
      if (channelName === CORP_STORE) {
        validOptions = validOptions.filter(option => {
          const optionValue = option.fields.value;
          // Remove ATL-only offers: $10 Bundle, $60 ATL, $45 ATL
          return optionValue !== vulTenDollarInternetBundleDiscount &&
                 optionValue !== vulSixtyDollarInternetDiscountATL &&
                 optionValue !== vulFortyFiveDollarInternetDiscountATL &&
                 optionValue !== vulFifteenDollarInternetBundleDiscountATL;
        });
      }

      return validOptions;
    }
    return [];
  };

  const addProductVulcanValue = getFieldValue(
    fieldAddProductVulcan,
    formFields
  );
  const fibreOfferFieldValue = getFieldValue(fibreOfferField, formFields);
  // Handle fibre offers visibility conditions
  if (fieldName === fibreOfferField) {
    const validOfferOptions = getValidOffersForSpeed(
      formFields,
      fieldName,
      fields
    );
    if (fibreOfferFieldValue && fibreOfferFieldValue.length > 0) {
      // Get the most recently selected option (last in array) or the first if single-select
      const lastSelectedValue = fibreOfferFieldValue[fibreOfferFieldValue.length - 1];
      const selectedOption = validOfferOptions.find(
        option => option.fields.value === lastSelectedValue
      );
      if (selectedOption) {
        const normalizedLabel = selectedOption.fields.label
          .toLowerCase()
          .trim();
        const normalizedATL = vulATLOption.toLowerCase().trim();
        const normalizedBTL = vulBTLOption.toLowerCase().trim();

        const isSelectedOptionBTL = normalizedLabel.includes(normalizedBTL);
        const isSelectedOptionATL = normalizedLabel.includes(normalizedATL);
        const isSelectedOptionBoth = isSelectedOptionATL && isSelectedOptionBTL;
        const isSelectedOptionATLOnly = isSelectedOptionATL && !isSelectedOptionBTL;
        const isSelectedOptionBTLOnly = isSelectedOptionBTL && !isSelectedOptionATL;

        if (isSelectedOptionBoth) {
          // When ATL+BTL option is selected, show all options (ATL-only, BTL-only, and ATL+BTL)
          fields.options = validOfferOptions;
        } else if (isSelectedOptionATLOnly) {
          // Show options that have ATL (ATL-only or ATL+BTL), filter out BTL-only options
          fields.options = validOfferOptions.filter(option => {
            const optionLabel = option.fields.label.toLowerCase().trim();
            return optionLabel.includes(normalizedATL);
          });
        } else if (isSelectedOptionBTLOnly) {
          // Show options that have BTL (BTL-only or ATL+BTL), filter out ATL-only options
          fields.options = validOfferOptions.filter(option => {
            const optionLabel = option.fields.label.toLowerCase().trim();
            return optionLabel.includes(normalizedBTL);
          });
        } else {
          fields.options = validOfferOptions;
        }
      } else {
        fields.options = validOfferOptions;
      }
    } else {
      fields.options = validOfferOptions;
    }
  }

  if (fieldName === fieldInstallation && orderData.isThisVulcanOrder) {
    formFields[fieldInstallation].value = [vulHundredDollarInstallationFee];
    disableOptions(fields.options, [vulHundredDollarInstallationFee], true);
  }

  if (fieldName === fieldAddProductVulcan && addProductVulcanValue) {
    if (
      addProductVulcanValue.includes(vulBusinessWifi) &&
      !formFields[fieldNumberOfAccessPoints].value
    ) {
      formFields[fieldSelectTheDevice].value = 'Meraki MR28';
      formFields[fieldNumberOfAccessPoints].value = 1;
    }else if (!addProductVulcanValue.includes(vulBusinessWifi)){
      formFields[fieldNumberOfAccessPoints].value = undefined;
      formFields[fieldSelectTheDevice].value = '';
    }
  }
};

export default FibreBusinessWifiHelpers;
